import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { exists } from '~/utils'

import {
  BRAND_ACCOUNT_AI_ENABLED_QUERY_KEY_PREFIX,
  useBrandAccountAiEnabledQueryKey,
} from './useBrandAccountAiEnabledQueryKey'

/**
 * Builds a callback that drops the cached brand-account AI-enabled flag.
 *
 * @param brandAccountId - Brand account to target. When omitted the callback
 *   invalidates every brand account by prefix, because the places that receive
 *   AI_DISABLED from the server do not always know which id it belongs to.
 * @returns Callback that performs the invalidation.
 */
export const useInvalidateBrandAccountAiEnabledQuery = (
  brandAccountId?: string,
) => {
  const queryClient = useQueryClient()
  const scopedQueryKey = useBrandAccountAiEnabledQueryKey(brandAccountId)
  const queryKey = React.useMemo(
    () =>
      exists(brandAccountId)
        ? scopedQueryKey
        : [BRAND_ACCOUNT_AI_ENABLED_QUERY_KEY_PREFIX],
    [brandAccountId, scopedQueryKey],
  )

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
